import { render, staticRenderFns } from "./awaitaudit.vue?vue&type=template&id=0fba63ae&scoped=true&"
import script from "./awaitaudit.vue?vue&type=script&lang=js&"
export * from "./awaitaudit.vue?vue&type=script&lang=js&"
import style0 from "./awaitaudit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/components.scss?vue&type=style&index=1&id=0fba63ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba63ae",
  null
  
)

export default component.exports